<template>
    <div id="detailtop" style="padding-top: 90px;" v-loading="loading" element-loading-background="rgba(17, 17, 17, 0.8)">
    
      <div style="margin: 5px;">
        <!-- 广告 -->
        <el-row :gutter="0">
  
          <el-col :xs="12*item.span" :sm="6*item.span" :md="6*item.span" :lg="4*item.span" v-for="(item,index) in indexadlist" :key="index"><!-- style="margin-bottom: -10px" -->

            <a :href="item.url" target="_blank">
              <el-image :title="item.title" error="@/assets/no_img.png" style="width: 100%;height: 100%;text-align: center;" class="" :src="item.image" fit="cover" >
                <template #error>
                  <div style="background-color: #000;color: #fff;">{{ item.title }}</div>
                </template>
              </el-image>
            </a>
  
          </el-col>
  
        </el-row>
      </div>
  
  
  
      <div class="size-body">
  
        
  
        <div style="min-height: 300px;">
          <div class="title-s">
            {{ typename }}
          </div>

          <div style="margin: 10px 30px;">

            <el-row :span="24">
              <el-col :xs="12" :sm="6" :lg="4" v-for="(item,index) in list" :key="index">
                <div class="list_text">
                  <div> <a :href="item.url" target="_blank" rel="noopener noreferrer">{{ item.text }}</a> </div>
                </div>

              </el-col>
              
            </el-row>

          </div>

          
        </div>
  
        
  
        
      </div>
      
    </div>
  </template>
  
  <script>
  import Hls from 'hls.js' 
  export default {
    name: 'LinklView',
    components: {
  
    },
    data(){
      return{
        loading:true,
        type:'',
        typename:'',
        list:[],
        indexadlist:[]
      }
    },
    mounted(e) {
      this.type = this.$route.query.type
      
      this.loadPage(this.type)

      var element = document.getElementById('pagetop');
          element.scrollIntoView({ behavior: "smooth" });

    },
    beforeDestroy() {
      
    },
    watch: {
      // 监听路由对象 $route 的变化
      '$route': {
        handler: function (to, from) {
          // 路由变化时执行的操作

          this.loading = true

          var element = document.getElementById('pagetop');
            element.scrollIntoView({ behavior: "smooth" });

          this.type = this.$route.query.type
          this.loadPage(this.type)


        },
        // 设置为深度监听
        deep: true
      }
    },
    methods: {
      loadPage(typename){
        var this_ = this

        // console.log(this.baseURL + "detail?id="+id)

        this.httpinfo.GetInfo(this,this.baseURL + "domainlink?mark="+this.baseMark+"&typename="+typename, function(e) {
          if(e.data.code==0){

            this_.typename = e.data.data.data.text
            this_.list = e.data.data.data.list
            this_.indexadlist = e.data.data.indexadlist

            let Temp_Rand_Arr = [],Temp_No_Rand_Arr = []
            this_.indexadlist.forEach(function(item){
                if(item.rand=='0'){
                Temp_Rand_Arr.push(item)
                }else{
                Temp_No_Rand_Arr.push(item)
                }
            })
            Temp_Rand_Arr.sort(() => Math.random() - 0.5) //随机位置
            this_.indexadlist = Temp_No_Rand_Arr.concat(Temp_Rand_Arr) //合并数组

          }
          this_.loading = false

        });
      },
    }
  }
  </script>
  <style>
  .list_text{
    margin: 5px;
    font-weight: bold;
    font-size: 16px;
  }
  </style>
  